/**
 * Zentrale Produktkonstanten.
 *
 * Ein Namenswechsel (z. B. auf "Scrollathlon") ist ein Edit an dieser Stelle
 * plus manifest.webmanifest und den Container-Namen in docker-compose.yml.
 */
export const APP_NAME = 'Scroll-o-Meter'
export const APP_CLAIM = 'Der Scrollathlon in drei Disziplinen'
export const APP_SHORT = 'Scrollometer'

/** Basis-URL der API. Im Docker-Betrieb proxyt nginx /api an den Backend-Container. */
export const API_BASE = import.meta.env.VITE_API_BASE ?? '/api'
